export default "__VITE_ASSET__BNiXxkbf__"